/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import * as React from 'react';
import OauthScopeModel from './Model';
import Object from 'apmui/util/Object';

export default class Scopes extends React.Component<{ scopes: { [id: string]: OauthScopeModel } }> {
    render() {
        const list = Object.values(this.props.scopes).map((scope: OauthScopeModel) => {
            return <li key={scope.id}>{scope.description ? scope.description : scope.caption}</li>;
        });

        return <ul>{list}</ul>;
    }
}
